import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import { Loading, Empty, SectionHeader, Card, fmtDate } from "./shared";
import { SelectableTable, SelectAllHeaderCheckbox, RowCheckbox } from "@/components/admin/SelectableTable";

export default function AdminDataSources() {
  const [sources, setSources] = useState(null);
  useEffect(() => { api.get("/admin/data-sources").then((r) => setSources(r.data.data_sources || [])).catch(() => setSources([])); }, []);
  if (sources === null) return <Loading />;
  return (
    <div data-testid="admin-data-sources">
      <SectionHeader title="Data Sources" subtitle="Tous les imports de données de la plateforme (lecture seule)." />
      {sources.length === 0 ? <Empty label="Aucune source de données." testid="sources-empty" /> : (
        <Card>
          <SelectableTable rows={sources} rowId={(s) => s.id} filename="admindatasources.csv" ariaLabel="Tableau — sélection et défilement">
            <table className="w-full min-w-[860px]">
              <thead><tr className="border-b border-slate-200 bg-slate-50 text-left text-xs font-semibold uppercase tracking-wider text-slate-500"><th className="px-3 py-2"><SelectAllHeaderCheckbox /></th>
                <th className="px-5 py-3">Organisation</th><th className="px-5 py-3">Source</th><th className="px-5 py-3">Type</th>
                <th className="px-5 py-3">Lignes</th><th className="px-5 py-3">Période</th><th className="px-5 py-3">Importé le</th>
              </tr></thead>
              <tbody>
                {sources.map((s) => (
                  <tr key={s.id} data-testid={`source-row-${s.id}`} className="border-b border-slate-100 last:border-0"><td className="px-3 py-2"><RowCheckbox id={s.id} /></td>
                    <td className="px-5 py-3 text-sm font-medium text-[#17201A]">{s.org_name}</td>
                    <td className="px-5 py-3 text-sm text-slate-600">{s.source_name}</td>
                    <td className="px-5 py-3 text-sm text-slate-600">{s.data_type}</td>
                    <td className="px-5 py-3 text-sm text-slate-600">{s.row_count}</td>
                    <td className="px-5 py-3 text-xs text-slate-500">{s.period_start && s.period_end ? `${s.period_start} → ${s.period_end}` : "—"}</td>
                    <td className="px-5 py-3 text-xs text-slate-500">{fmtDate(s.imported_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </SelectableTable>
        </Card>
      )}
    </div>
  );
}
